import { useQuery } from '@gogame/query';

import { loadPartners } from 'scenes/Integrations/sources/conversions/fields';

const PARTNERS = 'partners';

export const useLoadPartners = () => {
  return useQuery(PARTNERS, (_, { signal }) => loadPartners({}, signal));
};
